import React from 'react';

import { TableCell, TableRow, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { IInscription } from '../../../../types/inscription.type';
import { IProductType } from '../../../../types/product-type.type';

const sxCell: SxProps<Theme> = { textAlign: 'center' };
const sxNumberCell: SxProps<Theme> = { textAlign: 'center', fontWeight: 'bold' };

interface IProps {
  productType: IProductType;
  inscription: IInscription;
}

const InscriptionListItem = React.memo(({ inscription, productType }: IProps) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell sx={sxCell}>{inscription.school}</TableCell>
      <TableCell sx={sxCell}>{inscription.schoolYear}</TableCell>

      <TableCell sx={sxCell}>
        {t(`product_type.${inscription.productType.toLowerCase()}`)}
      </TableCell>

      <TableCell sx={sxCell}>{inscription.schoolLevel}</TableCell>

      {productType === IProductType.DISE && (
        <>
          <TableCell sx={sxCell}>{inscription.discipline}</TableCell>
          <TableCell sx={sxCell}>{inscription.taxon}</TableCell>
        </>
      )}

      <TableCell sx={sxNumberCell}>{inscription.quantity}</TableCell>
    </TableRow>
  );
});

export default InscriptionListItem;
